import React, { Component } from "react";
import trash from "views/profile/img/delete-2.svg";
import edit from "views/profile/img/edit.svg";
import { ChevronLeft, ChevronDown } from "react-feather";
import {
  getLANGUAGEMASTERAction,
  getSKILLMASTERAction,
  getRATINGMASTERAction,
} from "store/masters";
import {
  getlanguageAction,
  setLanguageAction,
  getSkillAction,
  saveSkillAction,
  getCertificationAction,
  saveCertificationAction,
  getPublicationAction,
  savePublicationAction,
} from "store/userWalkthrough";
import { connect } from "react-redux";
import kyc from "views/profile/img/kyc/kyc.png";
import DatePicker from "react-datepicker";
class Skill extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAddDetailsCertifications: true,
      CertificationText: null,
      Yearofcompletion: null,
      Remarks: null,
      Filedata: null,
      FileName: null,
    };
  }

  async saveSkills(e) {
    e.preventDefault();
    let CertDataJson = [
      {
        CertificationId: this.state.CertificationId,
        CertificationText: this.state.CertificationText,
        Yearofcompletion: new Date(this.state.Yearofcompletion).getFullYear(),
        Remarks: this.state.Remarks,
        Filedata: this.state.Filedata,
        FileName: this.state.FileName,
      },
    ];
    var obj = {
      CandidateNo: this.props.Auth.HCID,
      CertificationData: CertDataJson,
    };
    let response = await this.props.saveCertificationAction(obj);
    if (response.ResponseCode == 100) {
      await this.setState({ isAddDetailsCertifications: true });
      let skillResponse = await this.props.getCertificationAction(
        this.props.Auth.HCID
        // "3597108"
      );
    } else {
      alert(response.ResponseMessage);
    }
  }

  async componentDidMount() { }
  async emptyState() {
    this.setState({
      CertificationText: null,
      Yearofcompletion: null,
      Remarks: null,
      Filedata: null,
      FileName: null,
    });
  }
  async editCertification(x) {
    this.setState({
      isAddDetailsCertifications: false,
      CertificationId: x.CertificationId,
      CertificationText: x.CertificationText,
      Yearofcompletion: x.Yearofcompletion ? new Date(x.Yearofcompletion) : "",
      // new Date(x.Yearofcompletion).getFullYear(),
      Remarks: x.Remarks,
      Filedata: x.Filedata,
      FileName: x.FileName,
    });
  }
  getBase64(file) {
    let self = this;
    debugger;
    try {
      let name = file.target.files[0].name;
      var reader = new FileReader();
      reader.readAsDataURL(file.target.files[0]);
      reader.onload = function () {

        self.setState({ Filedata: reader.result, FileName: name });
      };
      reader.onerror = function (error) {
      };
    } catch (error) {
      alert("Error choosing file please try again.");
    }
  }
  ViewDocument(data) {
    var string = data.output("datauristring");
    var iframe =
      "<iframe width='100%' height='100%' src='" + string + "'></iframe>";
    var x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();
  }
  render() {
    return (
      <div className="">
        {this.state.isAddDetailsCertifications && (
          <div>
            <div>
              {/* Skills */}

              <div>
                <div className="flex justify-between ">
                  <div className="flex justify-between items-center w-full">
                    <p className="fsize16 text-black font-semibold">
                      Certifications
                    </p>

                    <button
                      className="outline-btn fsize16  misc-w158px font-semibold w-200px uppercase"
                      onClick={() => {
                        this.setState({
                          isAddDetailsCertifications:
                            !this.state.isAddDetailsCertifications,
                        });
                        this.props.setSkillView();
                        this.emptyState();
                      }}
                    >
                      ADD
                    </button>
                  </div>
                </div>
                <div className="grid lg:grid-cols-3 md:grid-cols-3 grid-cols-1 gap-8 mt-4">
                  {/* languages */}
                  {this.props.CERTIFICATIONS
                    ? this.props.CERTIFICATIONS.Data.map((x) => {
                      return (
                        <card className="rounded-sm borderblue-t-5px  drop-shadow20 bg-white block px-6 py-4 ">
                          <div className="flex justify-between 	">
                            <p className="text-black font-bold fsize16">
                              {" "}
                              {x.CertificationText}
                            </p>
                            <div className="flex items-center">
                              <img
                                src={edit}
                                alt="edit"
                                className="text053C6D w-5 h-5 "
                                onClick={() => this.editCertification(x)}
                              />
                            </div>
                          </div>
                          <p className="border707070-t opacity-20 my-4 	"></p>
                          <div>
                            <div className="flex justify-between mb-3">
                              <p className="text4B4B4B fsize14 opacity-70 w-5/12">
                                Year of Completion
                              </p>
                              <p className="text4B4B4B fsize14 opacity-70 w-1/12 text-center">
                                :
                              </p>

                              <p className="text4B4B4B fsize14 opacity-90 w-5/12 break-all">
                                {x.Yearofcompletion}
                              </p>
                            </div>{" "}
                            <div className="flex justify-between mb-3">
                              <p className="text4B4B4B fsize14 opacity-70 w-5/12">
                                Remarks
                              </p>
                              <p className="text4B4B4B fsize14 opacity-70 w-1/12 text-center">
                                :
                              </p>

                              <p className="text4B4B4B fsize14 opacity-90 w-5/12 break-all">
                                {x.Remarks}
                              </p>
                            </div>
                            <div className="flex justify-between mb-3">
                              <p className="text4B4B4B fsize14 opacity-70 w-5/12">
                                Document
                              </p>
                              <p className="text4B4B4B fsize14 opacity-70 w-1/12 text-center">
                                :
                              </p>

                              <p className="text4B4B4B fsize14 opacity-90 w-5/12 break-all">
                                <a
                                  href={x.Filedata}
                                  title="View Certificate"
                                  download={x.Filedata}
                                >
                                  <button
                                    className="btn btn1 font-bold"
                                    id="cc_resume"
                                  >
                                    view
                                  </button>
                                </a>
                              </p>
                            </div>
                          </div>
                        </card>
                      );
                    })
                    : " "}
                </div>
              </div>
              <div className="divider-card-b opacity-30 mt-8 mb-4"></div>
              {/* Certifications */}
            </div>
          </div>
        )}

        {!this.state.isAddDetailsCertifications && (
          <>
            <div className="relative">
              <form onSubmit={(e) => this.saveSkills(e)}>
                <div className="transform-tab cursor-pointer lg:block md:block hidden">
                  {/* <div className="flex justify-evenly items-center bgFDF1E7 rounded-8px h-41px w-200px">
                    <p className="text-black opacity-65 fsize14 font-semibold ">
                      Open Resume Tab
                    </p>
                    <ChevronDown className="text053C6D" />
                  </div> */}
                </div>
                <div>
                  <div
                    className="flex items-center cursor-pointer"
                    onClick={() =>
                      this.setState({
                        isAddDetailsCertifications:
                          !this.state.isAddDetailsCertifications,
                      })
                    }
                  >
                    <ChevronLeft className="text053C6D" />
                    <p
                      className="text-black fsize16 pl-2 font-semibold"
                      onClick={() => {
                        this.emptyState();
                      }}
                    >
                      Go back
                    </p>
                  </div>

                  <div className="mt-2 lg:w-3/4 md:w-3/4 w-full lg:pl-6 md:pl-6">
                    <div className="lg:flex md:flex items-center mb-1">
                      <div class="form-group modal-form-cs pt-4  lg:w-1/2 md:w-1/2  lg:pr-4 md:pr-4">
                        <label for="">Certification Text</label>

                        <input
                          required
                          type="text"
                          placeholder=""
                          className=" fsize16"
                          value={this.state.CertificationText}
                          onChange={(e) => {
                            this.setState({
                              CertificationText: e.target.value,
                            });
                          }}
                        />
                      </div>
                      <div class="form-group pt-4 modal-form-cs lg:w-1/2 md:w-1/2 w-full lg:pl-4 md:pl-4">
                        <label for="">Year of completion</label>

                        <div className="datepicker-w-full">
                          <DatePicker
                            required
                            selected={this.state.Yearofcompletion}
                            showYearPicker
                            dateFormat="yyyy"
                            onChange={(date) =>
                              this.setState({ Yearofcompletion: date })
                            }
                          />
                        </div>
                        {/* <input
                          required
                          type="text"
                          placeholder=""
                          className=" fsize16"
                          value={this.state.Yearofcompletion}
                          onChange={(e) => {
                            this.setState({ Yearofcompletion: e.target.value });
                          }}
                        /> */}
                      </div>
                    </div>
                  </div>

                  <div className="mt-2 lg:w-3/4 md:w-3/4 w-full lg:pl-6 md:pl-6">
                    <div className="lg:flex md:flex items-center mb-1">
                      <div class="form-group modal-form-cs pt-4  lg:w-1/2 md:w-1/2  lg:pr-4 md:pr-4">
                        <label for="">Remarks</label>

                        <input
                          required
                          type="text"
                          placeholder=""
                          className=" fsize16"
                          value={this.state.Remarks}
                          onChange={(e) => {
                            this.setState({ Remarks: e.target.value });
                          }}
                        />
                      </div>
                      <div class="form-group doc-form-cs pt-4  lg:w-1/2 md:w-1/2  lg:pl-4 md:pl-4">
                        <label for="">Document</label>

                        <input
                          required
                          type="file"
                          placeholder=""
                          className=" fsize16"
                          // value={this.state.Filedata}
                          onChange={(e) => {
                            this.getBase64(e);
                          }}
                        />
                      </div>
                    </div>
                    {this.state.Filedata ? (
                      <div className="lg:flex md:flex items-center mb-1">
                        <div class="form-group modal-form-cs pt-4  lg:w-1/2 md:w-1/2  lg:pr-4 md:pr-4">
                          <label for="">Previous</label>
                          <label>{this.state.FileName}</label>
                          {/* <img src={this.state.Filedata}></img> */}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="text-right sm-flex lg:mt-16 md:mt-16 mt-10">
                  <button
                    className="outline-button outline-border2px mis-add-btn w-230px sm-fsize14 h-50px font-semibold rounded-25px fsize16 mr-4"
                    onClick={() => {
                      this.setState({
                        isAddDetailsCertifications:
                          !this.state.isAddDetailsCertifications,
                      });
                      this.props.setSkillView();
                      this.emptyState();
                    }}
                  >
                    CANCEL
                  </button>
                  <button
                    className="filled-button w-230px filled-border2px sm-fsize14 h-50px  font-semibold rounded-25px fsize16 ml-4"
                    type="submit"
                  >
                    SAVE
                  </button>
                </div>
              </form>
            </div>
            <div className="divider-card-b opacity-30 mt-8 mb-4"></div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Auth: state.Auth.user,
    Profile: state.Profile.home.SINGLEAPPLICANTINFO,
    CERTIFICATIONS: state.userWalkthrough.info.CERTIFICATIONS,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCertificationAction: async (payload) =>
      await dispatch(getCertificationAction(payload)),

    saveCertificationAction: async (payload) =>
      await dispatch(saveCertificationAction(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Skill);
